import React from 'react';

const StarshipViewBackground = ({ children }) => {
  return (
    <div className="relative min-h-screen w-full bg-[#050a18] overflow-hidden font-sans">
      
      <div className="absolute inset-0 z-0 bg-[#050a18]">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0f1d] via-[#050a18] to-[#010204]" />
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(white, rgba(255,255,255,.2) 2px, transparent 3px)', backgroundSize: '50px 50px' }} />
      </div>

      <div className="absolute inset-0 z-10 animate-floating-viewscreen">
        <div className="absolute top-[30%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[70%] bg-blue-600/10 rounded-full blur-[150px]" />
        <div className="absolute bottom-[20%] right-[10%] w-[60%] h-[60%] bg-cyan-400/10 rounded-full blur-[120px]" />
        <div className="absolute top-1/4 right-[20%] w-[30%] h-[30%] bg-purple-900/10 rounded-full blur-[100px]" />
      </div>

      <div className="absolute inset-0 z-20 pointer-events-none p-10">
        <div className="absolute inset-0 border-[60px] border-transparent rounded-[80px] shadow-[inset_0_0_200px_rgba(0,0,0,0.95)]" />
        <div className="absolute top-0 left-0 h-full w-[25%] bg-[#02040a] rounded-r-[50%] opacity-90 filter blur-sm" />
        <div className="absolute top-0 right-0 h-full w-[25%] bg-[#02040a] rounded-l-[50%] opacity-90 filter blur-sm" />
      </div>
      <div className="relative z-30 min-h-screen">
        {children}
      </div>
    </div>
  );
};

export default StarshipViewBackground;